import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header'
import Seo from '../../Components/SeoComponent/Seo'
import Loader from '../../Loader';
import { FaEdit, FaSearch, FaTimes, FaTrash } from 'react-icons/fa';
import { CiMenuKebab } from "react-icons/ci";
import {
    CreateBeneficiaryGroup,
    BeneficiaryGroupReport,
    BeneficiaryGroupEdit,
    BeneficiaryGroupUpdate,
    BeneficiaryGroupDelete,
    CreateBeneficiary,
    BeneficiaryReport,
    BeneficiaryEdit,
    BeneficiaryUpdate,
    BeneficiaryDelete
} from '../../Services/PayoutService.js/Payouts';
import { showSuccessToast, showErrorToast } from '../../utils/toastUtils';

import { verifyIfscCodeService } from '../../Services';

import DataModal from '../../Components/ConfirmPopUp/DataModal';
import PaginationData from '../../Components/PaginationData';
const ManageBenificiary = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [ifscDetails, setIfscDetails] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [groupName, setGroupName] = useState('');
    const [description, setDescription] = useState('');
    const [packageData, setPackageData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [paginationData, setPaginationData] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [confirmDeleteData, setConfirmDeleteData] = useState(null);
    const [isConfirmModalOpenData, setIsConfirmModalOpenData] = useState(false);



    const [beneficiaryData, setBeneficaryData] = useState([]);

    const [errorText, setErrorText] = useState({
        message: '',
        type: 'error',
        field: ''
    });


    const [formData, setFormData] = useState({
        ifsc_code: '',
        account_no: '',
        confirm_ac: '',
        beneficiary_name: '',
        bank_name: '',
        branch_name: '',
        account_for: '',
        beneficiary_group_id: ''
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const verifyIfscCode = async () => {
        setErrorText({ message: '', type: '', field: '' });

        const code = formData.ifsc_code.trim().toUpperCase();
        if (!code) {
            setIfscDetails(null);
            return;
        }

        const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
        if (!regex.test(code)) {
            setIfscDetails(null);
            setErrorText({ message: 'Invalid IFSC', type: 'error', field: 'IFSC' });
            return;
        }

        setErrorText({ message: '✔', type: 'success', field: 'IFSC' });
        setIsLoading(true);

        try {
            const response = await verifyIfscCodeService(code);
            setIfscDetails(response);
        } catch (err) {
            setIfscDetails(null);
            setErrorText({ message: 'Failed to fetch IFSC details', type: 'error', field: 'IFSC' });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (formData.ifsc_code.length === 11) {
            verifyIfscCode();
        }
    }, [formData.ifsc_code]);


    // Add Beneficiary Data
    const handleAddBeneficiary = async () => {
        const {
            ifsc_code,
            account_no,
            confirm_ac,
            beneficiary_name,
            account_for,
            beneficiary_group_id,
        } = formData;

        if (!ifsc_code) {
            showErrorToast('Please Enter And Verfiy IFSC');
            return;
        }
        if (!account_no || !confirm_ac || !beneficiary_name || !account_for) {
            showErrorToast('Account No. , Name Field required');
            return;
        }

        if (account_no !== confirm_ac) {
            showErrorToast('Account numbers do not match');
            return;
        }

        const payload = {
            id: editId,
            name: beneficiary_name,
            account_number: account_no,
            ifsc_code: ifsc_code,
            bank_name: ifscDetails?.BANK || '',
            branch_name: ifscDetails?.BRANCH || '',
            is_vendor: account_for === 'vendor',
            is_salary: account_for === 'salary',
            beneficiary_group_id: beneficiary_group_id,
        };

        setIsLoading(true);

        let response;
        if (editId) {
            response = await BeneficiaryUpdate(
                String(payload.id),
                payload.name,
                payload.account_number,
                payload.ifsc_code,
                payload.bank_name,
                payload.branch_name,
                String(payload.beneficiary_group_id),
                payload.is_vendor,
                payload.is_salary
            );
        } else {
            response = await CreateBeneficiary(payload);
        }

        setIsLoading(false);

        if (response?.success !== false) {
            showSuccessToast(String(editId) ? 'Beneficiary updated' : 'Beneficiary added');
            setOpenMenuIndex(null);
            // Reset form
            setFormData({
                ifsc_code: '',
                account_no: '',
                confirm_ac: '',
                beneficiary_name: '',
                account_for: '',
                beneficiary_group_id: '',
            });
            setIfscDetails(null);
            setEditId(null);
            fetchBeneficiaries();
        } else {
            showErrorToast(response.message);
        }
    };



    useEffect(() => {
        verifyIfscCode();
    }, [formData.ifsc_code])



    const fetchBeneficiaries = async () => {
        try {
            setIsLoading(true);
            const response = await BeneficiaryReport(currentPage);
            if (response?.success !== false || response.data) {
                setBeneficaryData(response?.data || response.data.data || []);
                setPaginationData(response.pagination || response.data.pagination || {});
                setCurrentPage(response.pagination.current_page || 1);
                setLastPage(response.pagination.last_page || 1);
            } else {
                showErrorToast(response.message);
            }
        } catch (err) {
            showErrorToast('Something went wrong while fetching data');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBeneficiaries();
    }, [currentPage]);

    const toggleMenu = (index) => {
        setOpenMenuIndex(prev => (prev === index ? null : index));
    };

    const requestDelete2 = (id) => {
        setConfirmDeleteData({ id });
        setIsConfirmModalOpenData(true);
    };

    const confirmDelete2 = async () => {
        if (!confirmDeleteData?.id) return;

        try {
            const response = await BeneficiaryDelete(String(confirmDeleteData.id));
            if (response?.success !== false) {
                showSuccessToast('Beneficiary deleted successfully');
                setOpenMenuIndex(null);
                fetchBeneficiaries();
            } else {
                showErrorToast(response.message);
            }
        } catch (error) {
            showErrorToast('Something went wrong');
        } finally {
            setIsConfirmModalOpenData(false);
            setConfirmDeleteData(null);
        }
    };

    const filteredBeneficiaries = beneficiaryData.filter((b) =>
        b.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        b.account_number?.includes(searchTerm) ||
        b.bank_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    // Edit 2
    const handleEdit2 = async (id) => {
        try {
            setIsLoading(true);
            const response = await BeneficiaryEdit(String(id));
            setIsLoading(false);

            if (response?.data) {
                const data = response.data.beneficiary;
                setEditId(String(data.id));
                setFormData({
                    ifsc_code: data.ifsc_code,
                    account_no: data.account_number,
                    confirm_ac: data.account_number,
                    beneficiary_name: data.name,
                    account_for: data.is_salary ? 'salary' : 'vendor',
                    beneficiary_group_id: data.beneficiary_group_id,
                });

                // Set IFSC preview
                setIfscDetails({
                    BANK: data.bank_name,
                    BRANCH: data.branch_name
                });

                showSuccessToast('Loaded for editing');
            } else {
                showErrorToast(response.message || 'Failed to fetch details');
            }
        } catch (error) {
            setIsLoading(false);
            showErrorToast('Error fetching data for editing');
        }
    };



    const handleAddGroup = async () => {
        if (!groupName.trim()) {
            setErrorText({ message: 'Group Name is required', type: 'error', field: 'GROUP' });
            return;
        }

        const isDuplicate = packageData.some(
            (curr) => curr.group_name === groupName && curr.id !== editId
        );
        if (isDuplicate) {
            setErrorText({ message: 'Group Name is already added.', type: 'error', field: 'GROUP' });
            return;
        }

        setIsLoading(true);
        try {
            let response;
            if (isEditing) {
                response = await BeneficiaryGroupUpdate(String(editId), groupName, description);
            } else {
                response = await CreateBeneficiaryGroup({ name: groupName, description });
            }

            if (response?.status === 200 || response?.status.code === 200) {
                showSuccessToast(response.message || 'Group saved successfully');
                setGroupName('');
                setDescription('');
                setEditId(null);
                setIsEditing(false);
                await RetrieveGroupData(1);
                setCurrentPage(1);
            } else {
                showErrorToast(response.message || 'Failed to save group');
            }
        } catch (error) {
            showErrorToast("Unexpected error occurred");
        } finally {
            setIsLoading(false);
        }
    };

    // Retrieve Group Data
    const RetrieveGroupData = async (page = currentPage) => {
        try {
            setIsLoading(true);
            const response = await BeneficiaryGroupReport(page);
            if (response && response.data) {
                setPackageData(response.data || []);
                setPaginationData(response.pagination || {});
                setCurrentPage(response.pagination.current_page || 1);
                setLastPage(response.pagination.last_page || 1);
            }
        } catch (error) {
            showErrorToast(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        RetrieveGroupData(currentPage);
    }, [currentPage]);

    function handlePage(page) {
        setCurrentPage(page);
    }


    // Edit
    const handleEdit = async (id) => {
        try {
            const response = await BeneficiaryGroupEdit(String(id));
            if (response?.status === 200 || response.status.code === 200 && response?.data?.beneficiary_group) {
                const group = response.data.beneficiary_group;

                setGroupName(group.name || '');
                setDescription(group.description || '');
                setEditId(group.id);
                setIsEditing(true);

                setIsOpen(true); // ✅ Make sure modal opens!
            } else {
                showErrorToast(response.message || "Failed to fetch group data");
            }
        } catch (error) {
            showErrorToast("Unexpected error during edit");
        }
    };
    //ENd


    // Delete
    const requestDelete = (id) => {
        setConfirmDeleteId(id);
        setIsConfirmModalOpen(true);
    };
    // ENd


    // Handle Beneficiary Group Delete
    const confirmDelete = async () => {
        try {
            const response = await BeneficiaryGroupDelete(String(confirmDeleteId));
            if (response?.status?.code === 200) {
                showSuccessToast(response.message || "Deleted");
                await RetrieveGroupData(1);
                setCurrentPage(1);
            } else {
                showErrorToast(response.message || "Failed to delete group");
            }
        } catch (error) {
            showErrorToast("Something went wrong");
        } finally {
            setIsConfirmModalOpen(false);
            setConfirmDeleteId(null);
        }
    };
    // ENd


    return (
        < >
            <Header heading={'Manage Beneficiary'} />
            <Seo title={'Manage Beneficiary'} />



            {isConfirmModalOpenData && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">

                    <div className="bg-white rounded-xl p-2 shadow-md w-90">
                        <h3 className="text-md font-bold mb-2 text-red-700">Confirm Deletion</h3>
                        <p className="text-gray-700 mb-6">Are you sure you want to delete this group?</p>
                        <div className="flex justify-end gap-2">
                            <button
                                className="bg-gray-300 text-gray-800 px-2 py-1 rounded"
                                onClick={() => {
                                    setIsConfirmModalOpenData(false);
                                    setConfirmDeleteData(null);
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-red-600 text-white px-2 py-1 rounded"
                                onClick={confirmDelete2}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}




            {isConfirmModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">

                    <div className="bg-white rounded-xl p-2 shadow-md w-90">
                        <h3 className="text-md font-bold mb-2 text-red-700">Confirm Deletion</h3>
                        <p className="text-gray-700 mb-6">Are you sure you want to delete this group?</p>
                        <div className="flex justify-end gap-2">
                            <button
                                className="bg-gray-300 text-gray-800 px-2 py-1 rounded"
                                onClick={() => {
                                    setIsConfirmModalOpen(false);
                                    setConfirmDeleteId(null);
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-red-600 text-white px-2 py-1 rounded"
                                onClick={confirmDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}




            {isLoading && <Loader />}
            <DataModal visible={isOpen} onClose={() => setIsOpen(false)} className={'!p-0'}>
                <div className='w-full max-w-6xl p-2'>


                    <h4 className='text-blue-800 text-left font-bold text-xl '>Group </h4>
                    <div className="flex flex-col md:flex-row md:items-center md:gap-2 w-1/2">
                        {/* Group Name Input */}
                        <div className=" md:mb-0 w-full md:w-40 mt-1">
                            <input
                                type="text"
                                className={`border rounded outline-none bg-white shadow-sm font-semibold px-1 py-1 w-full md:w-40 ${errorText.field === 'GROUP' ? 'border-red-500' : 'border-gray-400'
                                    }`}
                                placeholder="Enter Group name"
                                name="name"
                                value={groupName}
                                onChange={(e) => setGroupName(e.target.value)}
                            />
                            {errorText.field === 'GROUP' && (
                                <p className="text-red-500 text-xs">{errorText.message}</p>
                            )}
                        </div>


                        {/* Description Input */}
                        <input
                            type="text"
                            className="border border-gray-400 rounded outline-none bg-white shadow-sm font-semibold px-2 py-1 w-full md:w-40 mb-2 md:mb-0"
                            placeholder="Enter Description"
                            name="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}

                        />

                        {/* Submit Button */}
                        <button
                            className="bg-blue-800 text-white font-semibold rounded-xl px-2 py-1 w-full md:w-40"
                            onClick={handleAddGroup}
                        >
                            {isEditing ? 'Update' : 'Submit'}
                        </button>
                        {isEditing && (
                            <button
                                className="bg-gray-600 text-white font-semibold rounded-xl px-2 py-1 mt-2 md:mt-0 md:ml-1"
                                onClick={() => {
                                    setGroupName('');
                                    setDescription('');
                                    setEditId(null);
                                    setIsEditing(false);
                                }}
                            >
                                Cancel
                            </button>
                        )}


                    </div>

                    <div>
                        <p className='text-xl font-semibold text-center text-blue-800'>Reports</p>
                        <table className='table w-full'>
                            <thead className='bg-gradient-to-r from-sky-800 to-blue-900 text-white '>
                                <th className='border-r'>SN</th>
                                <th className='border-r'>Code</th>
                                <th className='border-r'>Name</th>
                                <th className='border-r'>Description</th>
                                <th className='border-r'>Create At</th>
                                <th className='border-r'>Action</th>
                            </thead>
                            <tbody>
                                {packageData.length > 0 ? (
                                    packageData.map((curr, idx) => (
                                        <tr key={curr.id || idx} className="border border-gray-200 bg-white">
                                            {/* Serial Number with Pagination */}
                                            <td className=" border border-gray-200 font-bold">
                                                {(currentPage - 1) * (paginationData?.per_page || 10) + idx + 1}
                                            </td>

                                            <td className="border border-gray-200 text-sm">{curr?.code || "N/A"}</td>
                                            <td className="border border-gray-200 text-sm">{curr?.name || "N/A"}</td>
                                            <td className="border border-gray-200 text-sm">{curr?.description || "N/A"}</td>
                                            <td className="border border-gray-200 text-sm">
                                                {curr?.created_at
                                                    ? new Date(curr.created_at).toLocaleDateString("en-IN")
                                                    : "N/A"}
                                            </td>

                                            <td className="border border-gray-200">
                                                <div className="flex justify-center gap-2">
                                                    <FaEdit
                                                        className="bg-blue-800 text-white w-6 h-6 p-1 rounded-md cursor-pointer"
                                                        onClick={() => handleEdit(curr.id)}
                                                    />
                                                    <FaTrash
                                                        className="bg-red-800 text-white w-6 h-6 p-1 rounded-md cursor-pointer"
                                                        onClick={() => requestDelete(curr.id)}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="border border-gray-200 bg-white">
                                        <td colSpan={5} className="text-center py-4 text-gray-500">
                                            Data not found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                        <PaginationData currentPage={currentPage} lastPage={lastPage} handlePage={handlePage} />
                    </div>

                </div>

            </DataModal>
            <section className='flex flex-col sm:flex-row items-start gap-10 my-1'>


                <div className='bg-white shadow-md rounded-md border w-full md:w-[55%] p-2'>

                    {/* Search */}
                    <div className='flex items-center bg-gray-100 border border-blue-600 rounded-md px-2 mb-2'>
                        <FaSearch className='text-green-900 text-lg' />
                        <input
                            type='text'
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className='h-8 px-6 py-1 w-full outline-none bg-transparent text-md placeholder:text-black'
                            placeholder='Search by Name, Account, or Bank'
                        />
                    </div>

                    {/* Header */}
                    <p className='text-blue-700 mb-2 text-base font-bold border-b pb-1'>All Payees</p>

                    {/* List */}
                    <div className='space-y-1'>
                        {isLoading ? (
                            <p className='text-center text-sm text-gray-500'>Loading...</p>
                        ) : filteredBeneficiaries.length > 0 ? (
                            filteredBeneficiaries.map((curr, idx) => (
                                <div
                                    key={idx}
                                    className='bg-gray-100 hover:bg-blue-50 border border-gray-200 rounded-md transition-all duration-200 ease-in-out flex justify-between items-center px-1 py-1'
                                >
                                    {/* Left */}
                                    <div className='flex items-center gap-2'>
                                        <div className='bg-blue-800 text-white uppercase rounded-full h-8 w-9 flex items-center justify-center font-bold'>
                                            {curr.name?.slice(0, 1)}
                                        </div>
                                        <div>
                                            <p className='uppercase font-semibold text-gray-800 text-sm'>{curr.name}</p>
                                            <p className='text-gray-600 text-sm font-semibold'>{curr.bank_name || " "}<p className='text-xs inline-block font-normal'>({curr.branch_name || ""})</p> - {curr.account_number || ""}</p>
                                            {/* <p className='text-gray-600 text-xs'>{curr.}</p> */}
                                        </div>
                                    </div>

                                    {/* Right */}
                                    <div className='relative'>
                                        <button
                                            onClick={() => toggleMenu(idx)}
                                            className='p-0 rounded-full hover:bg-gray-200 transition duration-200'
                                        >
                                            <CiMenuKebab className='text-red-800 text-3xl font-bold' />
                                        </button>

                                        {openMenuIndex === idx && (
                                            <div className='absolute right-0 mt-2 bg-white border border-gray-300 rounded-md shadow-md p-2 z-20 flex gap-3'>
                                                <button
                                                    onClick={() => handleEdit2(curr.id)}
                                                    className='text-blue-600 hover:text-blue-800 transition'
                                                >
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    onClick={() => requestDelete2(curr.id)}
                                                    className='text-red-600 hover:text-red-800 transition'
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className='text-center font-medium text-gray-700'>No Beneficiary Added</p>
                        )}

                        <PaginationData currentPage={currentPage} lastPage={lastPage} handlePage={handlePage} />
                    </div>
                </div>




                <div className=' bg-white shadow-2xl shadow-blue-700 border md:w-[40%] w-full p-0 border-blue-800 rounded-bl-xl rounded-br-2xl md:mt-10 mt-1'>
                    <div className="relative -top-10 bg-blue-800 text-white text-md font-semibold px-4 py-1 rounded-tl-xl rounded-tr-2xl shadow-md flex justify-between items-center">
                        <span>Manage Beneficiary</span>
                        <button className="bg-green-700 text-white py-0 rounded border-white border-2 px-2" onClick={() => setIsOpen(true)}>Create Group</button>
                    </div>


                    <div className='w-5/6 my-0 px-2'>

                        {ifscDetails && (
                            <div className="flex flex-wrap gap-x-2 text-md">
                                <p className="text-nowrap">
                                    <span className="font-bold">Bank:</span>{' '}
                                    <span className="font-semibold">{ifscDetails?.BANK}</span>
                                </p>
                                <p className="text-nowrap">
                                    <span className="font-bold">Branch:</span>{' '}
                                    <span className="font-semibold">{ifscDetails?.BRANCH}</span>
                                </p>
                            </div>
                        )}


                        <div className='flex flex-col justify-start gap-2'>
                            <div className={`${errorText.field === 'IFSC' ? errorText.type === 'error' ? 'border-red-600' : 'border-green-600' : ''} flex border justify-between items-center px-2 border-gray-400 rounded bg-white shadow-sm`}>
                                <input
                                    type='text'
                                    name='ifsc_code'
                                    placeholder='Enter IFSC'
                                    value={formData.ifsc_code}
                                    onChange={handleChange}
                                    maxLength={11}
                                    className='h-10 font-semibold outline-none uppercase px-2'
                                />
                                <span className={`${errorText.field === 'IFSC' ? errorText.type === 'error' ? 'text-red-600' : 'text-green-600' : ''} font-bold`}>
                                    {errorText.field === 'IFSC' ? errorText.message : ''}
                                </span>
                            </div>


                        </div>

                        <div className='flex flex-col gap-2 items-start justify-start my-2 w-full'>
                            <input
                                type='password'
                                name='account_no'
                                placeholder='Beneficiary Account'
                                value={formData.account_no}
                                onChange={handleChange}
                                className='border border-gray-400 rounded outline-none bg-white shadow-sm font-semibold px-2 py-2 w-full'
                            />

                            <div className='w-full'>
                                <div className='flex w-full'>
                                    <input
                                        type='text'
                                        name='confirm_ac'
                                        placeholder='Confirm Account'
                                        value={formData.confirm_ac}
                                        onChange={handleChange}
                                        className='border border-gray-400 rounded-l outline-none bg-white shadow-sm font-semibold px-2 py-2 w-full'
                                    />
                                    <button className='border border-gray-400 border-l-0 rounded-r bg-blue-500 text-white font-bold px-4 py-1 hover:bg-blue-600'>
                                        Verify
                                    </button>
                                </div>
                            </div>
                        </div>

                        <input
                            type='text'
                            name='beneficiary_name'
                            placeholder='Beneficiary name'
                            value={formData.beneficiary_name}
                            onChange={handleChange}
                            className='border border-gray-400 rounded outline-none bg-white shadow-sm font-semibold px-2 py-2 w-full'
                        />

                        <div className='my-2 w-full'>
                            <select
                                name='beneficiary_group_id'
                                value={formData.beneficiary_group_id}
                                onChange={handleChange}
                                className='border border-gray-400 rounded outline-none bg-white shadow-sm font-semibold px-2 py-2 w-full'
                            >
                                <option value=''>Select Group</option>
                                {packageData?.map((group) => (
                                    <option key={group.id} value={group.id}>
                                        {group.name}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 my-2">
                            <label className="flex items-center gap-2 text-nowrap">
                                <input
                                    type="radio"
                                    name="account_for"
                                    value="salary"
                                    checked={formData.account_for === 'salary'}
                                    onChange={handleChange}
                                />
                                For Salary Payment
                            </label>
                            <label className="flex items-center gap-2 text-nowrap">
                                <input
                                    type="radio"
                                    name="account_for"
                                    value="vendor"
                                    checked={formData.account_for === 'vendor'}
                                    onChange={handleChange}
                                />
                                For Vendor Payment
                            </label>
                        </div>


                        <button
                            onClick={handleAddBeneficiary}
                            className='bg-blue-800 rounded-xl text-white font-semibold md:mx-auto py-2 px-5 md:ml-28 ml-16 my-2'
                            disabled={isLoading}
                        >
                            {isLoading
                                ? editId ? 'Updating...' : 'Saving...'
                                : editId ? 'Update Beneficiary' : 'Add Beneficiary'}
                        </button>


                    </div>

                    <div className='w-full md:my-2 my-0'>
                        <div class="relative bg-white border-red-500 border-2 rounded-md shadow-md md:p-3 p-1 max-w-md mx-auto mt-6">
                            <div class="absolute -top-7 left-0 bg-red-500 text-white text-sm font-semibold px-1 py-1 rounded-tl-xl rounded-tr-2xl  shadow-md">
                                Security First :
                            </div>
                            <ul class="list-disc list-inside md:text-sm text-xs text-gray-700 space-y-1">
                                <li className='font-semibold'>Don't pay to anyone without verifying account details It may lead to loose your money.</li>

                            </ul>
                        </div>

                    </div>

                </div>
            </section>
        </>
    )
}

export default ManageBenificiary
